import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const TeamPage = lazy(() => import("@/features/dashboard/pages/team"));

export const Route = createFileRoute("/(app)/dashboard/team")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground p-6 text-sm">Loading team...</div>}>
      <TeamPage />
    </Suspense>
  ),
});
